// src/ThemeContext.js
import { createContext, useState, useEffect } from 'react';
import { secureStorage } from "./utils/secureStorage";

export const ThemeContext = createContext();

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return secureStorage.getItem('theme') || 'dark';
  });

  const toggleTheme = async () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    secureStorage.setItem('theme', newTheme);

    try {
      await fetch(`${API_BASE_URL}/user/theme?theme=${newTheme}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${secureStorage.getItem('token')}`,
        },
      });
    } catch (error) {
      console.error('Failed to update theme on server', error);
    }
  };

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

